import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { policyView } from "../../../../redux/features/policyDetailsSlice";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import UploadBankNOC from "../../removeBankNameFlow/uploadBankNOC";
import UploadClaimHistory from "../../removeBankNameFlow/UploadClaimHistory";
import { getClientSource } from "../../../../utils/getClientSource";

const ClaimFileUploadHistory = () => {
  const [toggle, setToggle] = useState(false);
  const { policy_id } = useParams();
  const [PolicyNumber, setPolicyNumber] = useState(policy_id);
  const [Channel, setChannel] = useState(getClientSource());
  const dispatch = useDispatch();
  const policyDetails = useSelector(
    (state) => state.policyDetails.PolicyDetails
  );
  const policyDetailsStatus = useSelector(
    (state) => state.policyDetails.status
  );
  const policyDetailsError = useSelector((state) => state.policyDetails.error);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const translate = useLanguageTranslate();

  const navigate = useNavigate();
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    navigate(-1);
  };
  const polReq = {
    PolicyNumber,
    Channel,
  };

  const switchToggle = () => {
    navigate(-1);
  };

 

 

  return (
    <div className="mainCarDetailsModal pt-[80px] pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[30%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:pt-[0]">
    
      
        <UploadClaimHistory
          switchToggle={switchToggle}
          PolicyNo={policy_id}
          Bank={policyDetails?.PolicyHeader?.LenderCode}
        />
   
    </div>
  );
};

export default ClaimFileUploadHistory;
